import { TreatmentType } from 'app/core/enums';

const treatmentTypeImagesPrefix = `assets/images/treatment-type-images/`;
const fileTypeImagesPrefix = `assets/images/treatment-type-images/`;

export const TreatmentTypeImages = [
    {
        id: TreatmentType.NightGuard,
        name: 'Occlusal Guard',
        imagePath: `${treatmentTypeImagesPrefix}night-guard.png`,
    },
    {
        id: TreatmentType.SmileDesign,
        name: 'Smile Design',
        imagePath: `${treatmentTypeImagesPrefix}smile-design-new.webp`,
    },
    {
        id: TreatmentType.BracketRemoval,
        name: 'Bracket Removal',
        imagePath: `${treatmentTypeImagesPrefix}bracket-removal.webp`,
    },
    {
        id: TreatmentType.SurgicalGuide,
        name: 'Implant Planning and Surgical Guide',
        imagePath: `${treatmentTypeImagesPrefix}surgical-guide.webp`,
    },
    {
        id: 5,
        name: 'Removable Partial Denture',
        imagePath: `${treatmentTypeImagesPrefix}removable-partial-denture.webp`,
    },
    {
        id: TreatmentType.ClearAligner,
        name: 'Models for Clear Aligner Fabrication',
        imagePath: `${treatmentTypeImagesPrefix}clear-aligner.webp`,
    },
    {
        id: TreatmentType.SingleImplantWithCrown,
        name: 'Surgical Guide with Temporary Restoration',
        imagePath: `${treatmentTypeImagesPrefix}single-implant-with-crown.webp`,
    },
    {
        id: TreatmentType.CrownAndBridge,
        name: 'Crown and Bridges',
        imagePath: `${treatmentTypeImagesPrefix}cemented-restorations-new.webp`,
    },
    {
        id: TreatmentType.CustomBleachingTray,
        name: 'Models for Custom Bleaching Tray Fabrication',
        imagePath: `${treatmentTypeImagesPrefix}custom-bleaching-tray.webp`,
    },
    {
        id: TreatmentType.RemovableDentures,
        name: 'Removable Denture',
        imagePath: `${treatmentTypeImagesPrefix}removable-denture.webp`,
    },
    {
        id: TreatmentType.AINightGuard,
        name: 'AI Upper Nightguard',
        imagePath: `${treatmentTypeImagesPrefix}ai-nightguard-2.webp`,
    },
    { id: 12, name: 'DefinitiveCrown ', imagePath: `${treatmentTypeImagesPrefix}definitive-crown.webp` },
    {
        id: TreatmentType.HybridDentures,
        name: 'HybridDentures',
        imagePath: `${treatmentTypeImagesPrefix}hybrid-dentures.webp`,
    },
    { id: TreatmentType.AICrown, name: 'AI Crown', imagePath: `${treatmentTypeImagesPrefix}crown-ai.webp` },
    {
        id: TreatmentType.SmileCorrect,
        name: 'Smile Correct',
        imagePath: `${treatmentTypeImagesPrefix}smile-correct.webp`,
    },
    { id: TreatmentType.Veneers, name: 'Veneers', imagePath: `${treatmentTypeImagesPrefix}veneers-separated.png` },
    { id: TreatmentType.Moment, name: 'Moment', imagePath: `${treatmentTypeImagesPrefix}moment.png` },
    {
        id: TreatmentType.AICrownWithCAD,
        name: 'Studio Crown',
        imagePath: `${treatmentTypeImagesPrefix}studio-crown.webp`,
    },
    { id: TreatmentType.AIRetainer, name: 'AI Retainer', imagePath: `${treatmentTypeImagesPrefix}ai-retainer.webp` },
    { id: TreatmentType.DentalModel, name: 'Dental Model', imagePath: `${treatmentTypeImagesPrefix}dental-model.webp` },
    {
        id: TreatmentType.ImplantRestorations,
        name: 'Implant Restoration',
        imagePath: `${treatmentTypeImagesPrefix}implant-restoration.webp`,
    },
    {
        id: TreatmentType.ManualRetainer,
        name: 'Manual Restoration',
        imagePath: `${treatmentTypeImagesPrefix}retainer.webp`,
    },
];

export const TreatmentType3DViewerImage = [
    {
        id: TreatmentType.SurgicalGuide,
        imagePath: `${fileTypeImagesPrefix}surgical-guide.webp`,
    },
];

export const findTreatmentTypeImage = (treatmentType: TreatmentType) => {
    return TreatmentTypeImages.find(t => t.id === treatmentType);
};
